import { v4 as uuidv4 } from 'uuid';

export default {
    namespaced: true,

    state: {
        toasts: [],
    },

    mutations: {
        addToast(state, toast) {
            state.toasts.push({
                ...toast,
                uuid: uuidv4(),
            })
        }
    }


}
